// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sa-bg: #eef2f8;
  --sa-surface: #f6f8fc;
  --sa-card: #ffffff;
  --sa-card-hover: #f8fbff;
  --sa-border: #d9e2ef;
  --sa-border-light: #c2cfe2;
  --sa-text: #1f3756;
  --sa-muted: #6f85a4;
  --sa-dim: #90a2bc;
  --sa-accent: #2f6fe4;
  --sa-accent-glow: rgba(47, 111, 228, 0.24);
  --sa-red: #ef5350;
  --sa-green: #2563eb;
  /* Keep functional green */
  --sa-orange: #FF8A65;
  --sa-blue: #4DA8FF;
  --sa-teal: #3b82f6;
  --sa-purple: #B71C1C;
  --sa-gold: #FFD700;
}

.sa-container {
  display: flex;
  height: 100vh;
  background-color: var(--sa-bg);
  color: var(--sa-text);
  font-family: 'DM Sans', sans-serif;
  overflow: hidden;
}

.sa-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sa-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 28px;
}

.sa-card {
  background: var(--sa-card);
  border-radius: 14px;
  padding: 20px;
  border: 1px solid var(--sa-border);
  transition: transform 0.15s;
}

.sa-card:hover {
  transform: translateY(-2px);
  background: var(--sa-card-hover);
}

.sa-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.sa-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SATheme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[":root {\n  --sa-bg: #eef2f8;\n  --sa-surface: #f6f8fc;\n  --sa-card: #ffffff;\n  --sa-card-hover: #f8fbff;\n  --sa-border: #d9e2ef;\n  --sa-border-light: #c2cfe2;\n  --sa-text: #1f3756;\n  --sa-muted: #6f85a4;\n  --sa-dim: #90a2bc;\n  --sa-accent: #2f6fe4;\n  --sa-accent-glow: rgba(47, 111, 228, 0.24);\n  --sa-red: #ef5350;\n  --sa-green: #2563eb;\n  /* Keep functional green */\n  --sa-orange: #FF8A65;\n  --sa-blue: #4DA8FF;\n  --sa-teal: #3b82f6;\n  --sa-purple: #B71C1C;\n  --sa-gold: #FFD700;\n}\n\n.sa-container {\n  display: flex;\n  height: 100vh;\n  background-color: var(--sa-bg);\n  color: var(--sa-text);\n  font-family: 'DM Sans', sans-serif;\n  overflow: hidden;\n}\n\n.sa-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.sa-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 28px;\n}\n\n.sa-card {\n  background: var(--sa-card);\n  border-radius: 14px;\n  padding: 20px;\n  border: 1px solid var(--sa-border);\n  transition: transform 0.15s;\n}\n\n.sa-card:hover {\n  transform: translateY(-2px);\n  background: var(--sa-card-hover);\n}\n\n.sa-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.sa-badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
